import { createSelector } from 'reselect';
import { TEAM_ADMIN, TEAM_OWNER } from 'settings/constants/roles';

const localState = ({ agentTeamDetail }) => agentTeamDetail;

export const getAgentTeamDetailSelector = createSelector(
  localState,
  (agentTeamDetail) => agentTeamDetail,
);

export const getAgentTeamRoleSelector = createSelector(
  localState,
  (agentTeamDetail) => agentTeamDetail?.data?.TeamRole,
);

export const getIsAdminOrOwnerSelector = createSelector(localState, (agentTeamDetail) =>
  [TEAM_ADMIN, TEAM_OWNER].includes(agentTeamDetail?.data?.TeamRole),
);

export const getAgentTeamIdSelector = createSelector(
  localState,
  (agentTeamDetail) => agentTeamDetail?.data?.TeamId,
);

export const getAgentTeamIsActiveSelector = createSelector(
  localState,
  (agentTeamDetail) => !!agentTeamDetail?.data?.IsActive,
);

export const getAgentTeamCanCreateTranactionSelector = createSelector(
  localState,
  (agentTeamDetail) => !!agentTeamDetail?.data?.CanCreateTransaction,
);
